import { EComparisonNotificationCategory } from '../../types/comparison';
import { assertBadHttpStatus } from './assert/assertBadHttpStatus';
import { fetchDeleteOfferFromComparison } from '../../shared/repositories/offers-comparison/v1/delete-offer-from-comparison';
export async function removeFromComparison(_ref) {
  let {
    httpApi,
    logger,
    params
  } = _ref;
  try {
    const response = await fetchDeleteOfferFromComparison({
      httpApi,
      parameters: params
    });
    assertBadHttpStatus(response);
    const {
      text,
      comparisonUrl,
      offerId
    } = response.response;
    return {
      text,
      url: comparisonUrl,
      category: EComparisonNotificationCategory.Remove,
      offerId
    };
  } catch (error) {
    logger.error(error, {
      offerId: params.offerId,
      domain: 'removeFromComparison'
    });
  }
  return null;
}